import PinDropIcon from '@mui/icons-material/PinDrop';
import MapNavIcon from "../components/MapNavIcon";
import { DropoffDuotoneIcon, DriverDuotoneIcon, GroupDropoffDuotoneIcon } from 'components/svg';
export default function MapFilters({ filters, setFilters }) {
  const filterOptions = ['shipment', 'driver', 'dropoff'];
  return (
    <div
      className={`z-[400] flex items-center space-x-0`}
    >
      <MapNavIcon
        icon={<GroupDropoffDuotoneIcon fill={`${filters.shipment.showOnMap ? "#666" : "#bdbabd5e"}`} />}
        tooltipTitle='Shipments'
        onClick={() => {
          setFilters((prevState) => {
            const updatedFilters = { ...prevState };
            filterOptions.forEach(option => {
              updatedFilters[option] = {
                ...prevState[option],
                showOnMap: option === "shipment" ? !prevState.shipment.showOnMap : prevState[option].showOnMap,// Only show shipment on map
              };
            });
            return updatedFilters;
          });
        }}
      />
      <MapNavIcon
        icon={<DriverDuotoneIcon fill={`${filters.driver.showOnMap ? "#666" : "#bdbabd5e"}`} />}
        tooltipTitle="Drivers"
        onClick={() => {
          setFilters((prevState) => {
            const updatedFilters = { ...prevState };
            filterOptions.forEach(option => {
              updatedFilters[option] = {
                ...prevState[option],
                showOnMap: option === "driver" ? !prevState.driver.showOnMap : prevState[option].showOnMap, // Only toggle driver on map
              };
            });
            return updatedFilters;
          });
        }}
      />
      <MapNavIcon
        icon={<DropoffDuotoneIcon fill={`${filters.dropoff.showOnMap ? "#666" : "#bdbabd5e"}`} />}
        tooltipTitle="DropOffs"
        onClick={() => {
          setFilters((prevState) => {
            const updatedFilters = { ...prevState };
            filterOptions.forEach(option => {
              updatedFilters[option] = {
                ...prevState[option],
                showOnMap: option === "dropoff" ? !prevState.dropoff.showOnMap : prevState[option].showOnMap, // Only toggle driver on map
              };
            });
            return updatedFilters;
          });
        }}
      />
    </div>
  );
}
